import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-211a25f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ineed-tosign" }
const _hoisted_3 = { class: "ineed-tosign-title" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Preciso assinar")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Ver mais")
const _hoisted_6 = { class: "ineed-tosign-content" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Sem Documentos ", -1))
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "others-pending-sign" }
const _hoisted_10 = { class: "others-pending-sign-title" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Outras assinaturas pendentes")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Ver mais")
const _hoisted_13 = { class: "others-pending-sign-content" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Sem Documentos ", -1))
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { style: {"text-align":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_Header = _resolveComponent("Header")!
  const _component_HomeInfo = _resolveComponent("HomeInfo")!
  const _component_FileTextOutlined = _resolveComponent("FileTextOutlined")!
  const _component_EyeOutlined = _resolveComponent("EyeOutlined")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_DataTableINeedToSign = _resolveComponent("DataTableINeedToSign")!
  const _component_DataTableOthersPendingSign = _resolveComponent("DataTableOthersPendingSign")!
  const _component_HeaderContent = _resolveComponent("HeaderContent")!
  const _component_HomeContent = _resolveComponent("HomeContent")!
  const _component_FooterContent = _resolveComponent("FooterContent")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { class: "main" }, {
    default: _withCtx(() => [
      _createVNode(_component_Sidebar, {
        "envelopes-consummation": _ctx.envelopesConsummation,
        "envelopes-limit": _ctx.envelopesLimit
      }, null, 8, ["envelopes-consummation", "envelopes-limit"]),
      _createVNode(_component_a_layout, null, {
        default: _withCtx(() => [
          _createVNode(_component_Header),
          _createVNode(_component_HomeInfo, {
            "is-mobile": _ctx.isMobile,
            "is-home": _ctx.isHome,
            "is-action-admin-or-sys-admin": _ctx.isActionAdminOrSysAdmin,
            onUpdateHomeInfo: _ctx.handleHomeInfoUpdate
          }, null, 8, ["is-mobile", "is-home", "is-action-admin-or-sys-admin", "onUpdateHomeInfo"]),
          _createVNode(_component_a_layout_content, { class: "body-envelope" }, {
            default: _withCtx(() => [
              (_ctx.isHome)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("span", _hoisted_3, [
                        _createVNode(_component_FileTextOutlined, { class: "ic-files" }),
                        _hoisted_4
                      ]),
                      _createElementVNode("span", {
                        class: "ineed-tosign-more",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getEnvelopesByStatus(1)))
                      }, [
                        _createVNode(_component_EyeOutlined, { class: "ic-view-more" }),
                        _hoisted_5
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        (_ctx.envelopsINeedToSign.length == 0)
                          ? (_openBlock(), _createBlock(_component_a_empty, {
                              key: 0,
                              style: {"margin-top":"20px"}
                            }, {
                              description: _withCtx(() => [
                                _hoisted_7
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              _createVNode(_component_DataTableINeedToSign)
                            ]))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, [
                        _createVNode(_component_FileTextOutlined, { class: "ic-files" }),
                        _hoisted_11
                      ]),
                      _createElementVNode("span", {
                        class: "others-pending-sign-more",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getEnvelopesByStatus(6)))
                      }, [
                        _createVNode(_component_EyeOutlined, { class: "ic-view-more" }),
                        _hoisted_12
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        (_ctx.envelopsOthersPendingSign.length == 0)
                          ? (_openBlock(), _createBlock(_component_a_empty, {
                              key: 0,
                              style: {"margin-top":"20px"}
                            }, {
                              description: _withCtx(() => [
                                _hoisted_14
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createVNode(_component_DataTableOthersPendingSign)
                            ]))
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("section", _hoisted_17, [
                      _createVNode(_component_HeaderContent)
                    ]),
                    _createVNode(_component_HomeContent)
                  ])),
              _createElementVNode("div", null, [
                (_ctx.hasEnvelope && !_ctx.isHome)
                  ? (_openBlock(), _createBlock(_component_FooterContent, { key: 0 }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Footer)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}